/**
 * Default User Settings
 */
import OrderStatusEnum from '@/api/Enums/OrderStatusEnum.js'
import SourceTypeEnum from '@/api/Enums/SourceTypeEnum.js'

const DefaultUserSettings = {
  ExcludeFromPin: false,
  AllUsers      : {
    Permissions: {
      CanTransactionManualAccept         : false,
      CanTransactionManualAcceptAllStates: false,
      CanDeleteOrder                     : true,
      CanAddOrderDiscount                : true,
      CanAddOrderDiscountCustom          : true,
      CanCopyProductOptions              : false,
      CanPrintOrderDocument              : true,
      CanPrintOrderPreparation           : true,
      CanPrintOrderFiscal                : true,
      CanPrintReportZ                    : true,
      CanPrintMarketing                  : true,
      CanPrintDeliveryShift              : true,
      CanPrintWaiterShift                : true
    },
    ActivePaymentTypes: {
      Active: false,
      Items : []
    },
    ActiveEftPos: {
      Active: false,
      Items : []
    },
    ActivePrintMachineGroups: {
      Active: false,
      Items : []
    },
    Catalogs      : [],
    DefaultCatalog: 0
  },
  DeliveryStaff: {
    TrackLocation: false,
    Permissions  : {
      CanOpenShift              : false,
      CanCloseShift             : false,
      CanAddOrder               : false,
      CanDeleteOrder            : false,
      CanTransactionSale        : false,
      CanGenerateDocument       : false,
      IsGenerateDocumentRequired: false,
      CanPrintDocument          : false,
      CanTransactionRefund      : false
    }
  },
  Tables: {
    Waiter: {
      Permissions: {
        WaiterCanManagePos                : false,
        WaiterCanChangeTableWaiter        : false,
        WaiterCanManageAllTables          : false,
        WaiterCanSetCustomPrice           : false,
        WaiterCanChangeExternalReceipt    : false,
        WaiterCanCompleteOrderWithoutPrint: false
      }
    }
  },
  Orders: {
    Permissions: {
      Daily    : true,
      Saved    : true,
      Scheduled: false,
      All      : true
    },
    VisibleStatuses: [OrderStatusEnum.Received, OrderStatusEnum.Accepted, OrderStatusEnum.Preparation, OrderStatusEnum.Delivery, OrderStatusEnum.Completed, OrderStatusEnum.Canceled],
    SourceTypes    : [SourceTypeEnum.ALL]

  }
}

export default DefaultUserSettings
